/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// App - BookThatApp
// ==================================================================================================== //
var cstBTA = {
  detectIntervalSec: 0.5,
  quantReTry: 0,
  limitReTry: 60,
};

//link タグ href に入るパス： 追加したいCSSファイルを指定
cstBTA.CSSPaths = [
  "https://cdn.shopify.com/s/files/1/0548/8928/3662/t/2/assets/c-bookthatapp.css?v=1.1.4",
];
//script タグ src に入るパス： JavaScriptファイルを指定
cstBTA.JSPaths = [];

//本体 HTML から呼び出し
setTimeout(cstBTALaunch, 1000 * 3);

function cstBTALaunch() {
  var isDeteced = false;

  cstBTA.quantReTry++;

  //BTA ウィジェット検知
  var nBTAParent = document.getElementById("bta-product-widget");
  if (nBTAParent) {
    var nBTAFrame = nBTAParent.getElementsByTagName("iframe")[0];
    if (nBTAFrame) {
      isDeteced = true;
    }
  }

  //#######################################
  //bta 関連エレメントが無い場合はスクリプト実行中断
  if (isDeteced == false) {
    if (cstBTA.quantReTry < cstBTA.limitReTry) {
      setTimeout(cstBTALaunch, 1000 * cstBTA.detectIntervalSec);
    }
  } else {
    //iframe ドキュメントHTMLを取得
    cstBTA.winBTAWidget = nBTAFrame.contentWindow;
    cstBTA.nDocBTAWidget = cstBTA.winBTAWidget.document;
    var nWidgetHead = cstBTA.nDocBTAWidget.getElementsByTagName("head")[0];

    //CSS
    for (var i = 0; i < cstBTA.CSSPaths.length; i++) {
      var path = cstBTA.CSSPaths[i];
      var nAppendCSS = cstBTA.nDocBTAWidget.createElement("link");
      nAppendCSS.setAttribute("rel", "stylesheet");
      nAppendCSS.setAttribute("href", path);
      nWidgetHead.appendChild(nAppendCSS);
    }

    //JS
    for (var i = 0; i < cstBTA.JSPaths.length; i++) {
      var path = cstBTA.JSPaths[i];
      var nAppendJS = cstBTA.nDocBTAWidget.createElement("script");
      nAppendJS.setAttribute("src", path);
      nWidgetHead.appendChild(nAppendJS);
    }
  }
}

// App - 定期購買
// ==================================================================================================== //
setTimeout(function () {
  document.getElementsByClassName(
    "huckleberry-subscription-list-title",
  ).innerText = "定期便一覧";
}, 3000);

// Line Item Property - アフターブーケ
// => snippets/c_product-info.liquid
// ==================================================================================================== //
// 持ち込み・配送オプション
// ---------------------------------------- //
document.addEventListener("DOMContentLoaded", function () {
  const ids = {
    flag: "product-form__howtosend__flag",
    mochikomi: "product-form__howtosend__mochikomi",
    yoyaku: "product-form__howtosend__yoyaku",
    //shop: "product-form__howtosend__shop",
    box: "product-form__howtosend__box",
  };

  const flag = document.getElementById(ids.flag);
  const mochikomi = document.getElementById(ids.mochikomi);
  const yoyaku = document.getElementById(ids.yoyaku);
  //const shop = document.getElementById(ids.shop);
  const box = document.getElementById(ids.box);

  const wrappers = {
    mochikomi: document.getElementById(
      "product-form__howtosend__mochikomi__wrapper",
    ),
    yoyaku: document.getElementById("product-form__howtosend__yoyaku__wrapper"),
    //booking: document.getElementById("product-form__howtosend__booking"),
    formNote: document.getElementById(
      "product-form__howtosend__form-note__wrapper",
    ),
    //formOsaka: document.getElementById("product-form__howtosend__form-osaka__wrapper"),
    //formTokyo: document.getElementById("product-form__howtosend__form-tokyo__wrapper"),
    //formNara: document.getElementById("product-form__howtosend__form-nara__wrapper"),
    box: document.getElementById("product-form__howtosend__box__wrapper"),
  };

  const engravingOption = document.getElementById(
    "product-form__engraving-option",
  );
  const quantitySelector = document.getElementById(
    "product-form__quantity-selector",
  );
  const buyButton = document.getElementById("AddToCart");

  //const allSelects = [flag, mochikomi, yoyaku, shop, box];
  const allSelects = [flag, mochikomi, yoyaku, box];
  const initialNames = new Map();
  allSelects.forEach((el) => {
    if (el && el.name) initialNames.set(el.id, el.name);
  });

  // 表示切り替え & name制御
  function toggleWrapper(wrapper, show) {
    if (!wrapper) return;
    wrapper.style.display = show ? "" : "none";
    const inputs = wrapper.querySelectorAll("select, input, textarea");
    inputs.forEach((input) => {
      if (show) {
        input.disabled = false;
        input.required = true;
        input.name =
          initialNames.get(input.id) || input.dataset.originalName || "";
      } else {
        input.disabled = true;
        input.required = false;
        if (input.name) input.dataset.originalName = input.name;
        input.removeAttribute("name");
      }
    });
  }

  function hideAll() {
    Object.values(wrappers).forEach((w) => toggleWrapper(w, false));
  }

  function resetSelect(select) {
    if (select) select.value = "";
  }

  const toggleDisplay = (el, show) => {
    if (!el) return;
    el.style.display = show ? "" : "none";
  };

  // メイン制御
  function viewChangeHowToSend() {
    hideAll();

    const flagVal = flag.value;
    const mochikomiVal = mochikomi.value;
    const yoyakuVal = yoyaku.value;
    //const shopVal = shop.value;

    // 表示状態リセット
    toggleDisplay(engravingOption, true);
    toggleDisplay(quantitySelector, true);
    toggleDisplay(buyButton, true);
    //quantitySelector.forEach(q => toggleDisplay(q, true));
    //buyButton.forEach(b => toggleDisplay(b, true));

    if (flagVal === "ご来店持ち込み") {
      resetSelect(box);
      toggleWrapper(wrappers.mochikomi, true);

      if (mochikomiVal === "持ち込み済") {
        resetSelect(yoyaku);
        //resetSelect(shop);
        return;
      }

      if (mochikomiVal === "持ち込み予定") {
        toggleWrapper(wrappers.yoyaku, true);

        if (yoyakuVal === "予約済") {
          //resetSelect(shop);
          return;
        }

        if (yoyakuVal === "未予約") {
          //toggleWrapper(wrappers.booking, true);

          // 刻印、数量、購入ボタンを非表示
          toggleDisplay(engravingOption, false);
          toggleDisplay(quantitySelector, false);
          toggleDisplay(buyButton, false);
          toggleWrapper(wrappers.formNote, true);
        }
      }
    } else if (flagVal === "配送") {
      resetSelect(mochikomi);
      toggleWrapper(wrappers.box, true);
    }
  }

  // 初期化処理（ページロード / ブラウザバック時）
  function resetAll() {
    allSelects.forEach(resetSelect);
    hideAll();

    // 刻印サービス系もリセット
    // - 刻印select：未選択に戻し、change発火で連動UIも初期化
    // - 印字する日付とお名前：テキストを空に
    const engravingSelect = engravingOption?.querySelector("select");
    const engravingDateAndName = document.getElementById(
      "line-item-property__field__engraving__dateandname",
    );
    if (engravingSelect) {
      engravingSelect.value = "";
      engravingSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (engravingDateAndName) {
      engravingDateAndName.value = "";
    }
  }

  // イベントバインド（HTML側のonchange不要）
  // 20260518変更 - engravingフィールドが存在しない商品でイベント発火しない不具合のため、フィールド値が変更されるたびにvalidateForm()を呼び出すよう変更。
  allSelects.forEach((sel) => {
    sel &&
      sel.addEventListener("change", function () {
        viewChangeHowToSend();
        window.initResource?.validateForm?.();
      });
  });

  // 初期リセット
  resetAll();

  // ブラウザバック・進む時にも確実にリセット
  // （bfcache 復元時には DOMContentLoaded が走らないため、
  //  親=配送 が復元されているのに子wrapper非表示=name無し、というズレが発生する。
  //  また通常リロード後でもブラウザのフォーム値復元がレース条件で走るケースに対応。）
  window.addEventListener("pageshow", function () {
    resetAll();
  });
});

// 名前空間を作成
window.initResource = window.initResource || {};

// 必須項目未入力の場合カートに入れるボタンを無効化
// ---------------------------------------- //
(function () {
  const buttonId = "AddToCart";
  const formSelector = ".ProductForm__memorial-bouquet";

  // 必須項目チェック
  // -------------------------
  function validateForm() {
    const form = document.querySelector(formSelector);
    const button = document.getElementById(buttonId);
    if (!form || !button) return;

    const requiredFields = [
      ...form.querySelectorAll(
        "input[required], select[required], textarea[required]",
      ),
      ...document.querySelectorAll(
        ".product-form__confirmation-gate input[required]",
      ),
    ];

    const allFilled = Array.from(requiredFields).every((field) => {
      if (field.type === "checkbox" || field.type === "radio")
        return field.checked;
      return field.value.trim() !== "";
    });

    button.disabled = !allFilled;
  }
  window.initResource.validateForm = validateForm;

  // 入力イベントを再バインド
  // -------------------------
  function bindValidationEvents() {
    const form = document.querySelector(formSelector);
    if (!form) return;

    const requiredFields = form.querySelectorAll(
      "input[required], select[required], textarea[required]",
    );
    requiredFields.forEach((field) => {
      field.removeEventListener("input", validateForm);
      field.removeEventListener("change", validateForm);
      field.addEventListener("input", validateForm);
      field.addEventListener("change", validateForm);
    });

    document
      .querySelectorAll(".product-form__confirmation-gate input[required]")
      .forEach((field) => {
        field.removeEventListener("input", validateForm);
        field.removeEventListener("change", validateForm);
        field.addEventListener("input", validateForm);
        field.addEventListener("change", validateForm);
      });

    validateForm();
  }

  // variant radio 切り替え時
  // -------------------------
  function bindVariantEvents() {
    const radios = document.querySelectorAll(
      '[data-block-type="variant-picker"] input[type="radio"]',
    );
    radios.forEach((radio) => {
      radio.removeEventListener("change", validateForm);
      radio.addEventListener("change", validateForm); // 入力状態チェックだけ
    });
  }

  // DOM変化監視（Ajax再描画対応）
  // -------------------------
  function setupMutationObserver() {
    const observer = new MutationObserver(() => {
      bindVariantEvents();
      bindValidationEvents();
      validateForm();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // 初期化
  // -------------------------
  function init() {
    bindVariantEvents();
    bindValidationEvents();
    validateForm();
    setupMutationObserver();
  }

  if (window.Shopify && window.Shopify.theme) {
    window.Shopify.theme.ready(init);
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }
})();

// 【ご来店予約】ブライダル装花のご相談の店舗選択
// => /products/booking-wedding-flowers
// ---------------------------------------- //
document.addEventListener("DOMContentLoaded", function () {
  const select = document.querySelector(
    "#product-info__booking-form__location",
  );
  if (!select) return;
  const wrappers = {
    大阪: document.querySelector(
      "#product-info__booking-form__location__osaka__wrapper",
    ),
    奈良: document.querySelector(
      "#product-info__booking-form__location__nara__wrapper",
    ),
    東京: document.querySelector(
      "#product-info__booking-form__location__tokyo__wrapper",
    ),
  };
  const noteWrapper = document.querySelector(
    "#product-info__booking-form__location__note__wrapper",
  );

  function updateDisplay() {
    const value = select.value;

    // 店舗ごとのフォーム切替
    for (const key in wrappers) {
      if (wrappers[key]) {
        wrappers[key].style.display = key === value ? "block" : "none";
      }
    }

    // 注釈の表示切替
    if (["大阪", "奈良", "東京"].includes(value)) {
      noteWrapper.style.display = "block";
    } else {
      noteWrapper.style.display = "none";
    }
  }

  updateDisplay();

  select.addEventListener("change", updateDisplay);
});

// 刻印サービス
// ---------------------------------------- //
document.addEventListener("DOMContentLoaded", () => {
  // 刻印セレクト要素の表示切替関数
  function updateEngravingView(selectEl) {
    if (!selectEl) return;

    const engravingFlag = selectEl.value;
    const requiredWrapper = document.getElementById(
      "line-item-property__field__engraving__required",
    );
    const dateAndNameEl = document.getElementById(
      "line-item-property__field__engraving__dateandname",
    );

    if (!requiredWrapper || !dateAndNameEl) return;

    if (engravingFlag === "要") {
      requiredWrapper.style.display = "";
      dateAndNameEl.setAttribute("required", "");
    } else {
      requiredWrapper.style.display = "none";
      dateAndNameEl.value = "";
      dateAndNameEl.removeAttribute("required");
    }

    dateAndNameEl.removeEventListener(
      "input",
      window.initResource.validateForm,
    );
    dateAndNameEl.removeEventListener(
      "change",
      window.initResource.validateForm,
    );
    dateAndNameEl.addEventListener("input", window.initResource.validateForm);
    dateAndNameEl.addEventListener("change", window.initResource.validateForm);
  }

  // 初期セットアップ
  function initEngravingObserver() {
    const formWrapper = document.getElementById(
      "product-form__engraving-option",
    );

    if (!formWrapper) return;

    const selectEl = formWrapper.querySelector("select");

    // 初回表示用
    updateEngravingView(selectEl);

    // changeイベントを監視
    selectEl?.addEventListener("change", () => updateEngravingView(selectEl));

    // DOMが再描画された場合も対応するMutationObserver
    const observer = new MutationObserver(() => {
      const updatedSelect = formWrapper.querySelector("select");
      if (updatedSelect && updatedSelect !== selectEl) {
        // 古いイベントリスナーを置き換える
        updatedSelect.addEventListener("change", () =>
          updateEngravingView(updatedSelect),
        );
        updateEngravingView(updatedSelect);
      }
    });

    observer.observe(formWrapper, { childList: true, subtree: true });
  }

  initEngravingObserver();
});

// Line Item Property - メタフィールド追加オプション
// ==================================================================================================== //
document
  .querySelectorAll(".ProductForm__AddedOption input[type='radio']")
  .forEach((radio) => {
    radio.addEventListener("click", () => {
      if (radio.classList.contains("is-checked")) {
        radio.classList.remove("is-checked");
        radio.checked = false;
      } else {
        document
          .querySelectorAll(
            ".ProductForm__AddedOption input[type='radio'].is-checked",
          )
          .forEach((checkedRadio) => {
            checkedRadio.classList.remove("is-checked");
          });
        radio.classList.add("is-checked");
      }
    });
  });

// お問い合わせフォーム - ご要件によるブーケお持込み店舗の出し分け
// => sections/c_contact.liquid
// ---------------------------------------- //
document.addEventListener("DOMContentLoaded", function () {
  const trigger = "【アフターブーケ】ブーケのお持込みについて";
  const contentSelect = document.querySelector("#contact-form-content select");
  const mochikomiWrap = document.querySelector(
    "#contact-form-afterbouquet_mochikomi",
  );
  if (!contentSelect || !mochikomiWrap) return;
  const mochikomiSelect = mochikomiWrap.querySelector("select");

  function sync() {
    const show = contentSelect.value === trigger;
    mochikomiWrap.hidden = !show;
    if (!mochikomiSelect) return;
    if (show) {
      mochikomiSelect.setAttribute("required", "");
    } else {
      mochikomiSelect.removeAttribute("required");
      mochikomiSelect.value = "";
    }
  }

  contentSelect.addEventListener("change", sync);
  sync();
});

// js/custom-element/ui/link-bar.js
// ==================================================================================================== //
var LinkBar = class extends HTMLElement {
  connectedCallback() {
    const selectedItem = this.querySelector(".link-bar__link-item--selected");
    if (selectedItem) {
      requestAnimationFrame(() => {
        selectedItem.style.scrollSnapAlign = "none";
      });
    }
  }
};
window.customElements.define("link-bar", LinkBar);

// App - Easify Custom Product Options
// ==================================================================================================== //
document.addEventListener("DOMContentLoaded", function () {
  // オプション名のマッピング (Text → Value)
  const MAP = {
    ラッピング: "wrapping",
    ギフトラッピング: "wrapping",
    メッセージカード: "card",
  };

  const BUTTON_OPTIONS = ["wrapping", "card"];
  const ROW_SELECTOR = ".po-buttons-optionGroup, .po-checkbox-options";

  // ナビボタンの状態更新
  function sync(row, prev, next, wrap) {
    const max = row.scrollWidth - row.clientWidth;
    const overflow = max > 1;

    wrap.classList.toggle("is-overflow", overflow);
    prev.disabled = !overflow || row.scrollLeft <= 1;
    next.disabled = !overflow || row.scrollLeft >= max - 1;
  }

  // ナビボタン生成
  function createNavButton(type) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "c-option-nav c-option-nav--" + type;
    button.setAttribute("aria-label", type === "prev" ? "前へ" : "次へ");
    return button;
  }

  // カルーセル構築
  function setupCarousel(row) {
    if (row.dataset.carouselReady) return;
    if (!row.closest(".po-field-root")) return;

    const wrap = document.createElement("div");
    wrap.className = "c-option-carousel";
    row.parentNode.insertBefore(wrap, row);
    wrap.appendChild(row);

    const prev = createNavButton("prev");
    const next = createNavButton("next");

    function scrollByCard(direction) {
      const item = row.firstElementChild;
      const gap = parseFloat(getComputedStyle(row).gap) || 8;
      const distance = (item ? item.offsetWidth : 120) + gap;

      row.scrollBy({
        left: direction * distance,
        behavior: "smooth",
      });
    }

    function update() {
      sync(row, prev, next, wrap);
    }

    prev.addEventListener("click", function () {
      scrollByCard(-1);
    });
    next.addEventListener("click", function () {
      scrollByCard(1);
    });
    row.addEventListener("scroll", update, { passive: true });

    wrap.append(prev, next);
    row.dataset.carouselReady = "1";

    new ResizeObserver(update).observe(row);
    update();
  }

  // カスタム属性・クラス付与
  function markOption(option) {
    if (option.dataset.optionReady) return;

    let key;

    if (option.querySelector(".po-checkbox-root")) {
      key = "crosssell";
    } else if (option.querySelector(".po-textArea-root")) {
      key = "message";
    } else {
      const labelEl = option.querySelector(".po-label-label");
      if (!labelEl) return;
      key = MAP[labelEl.textContent.trim()];
    }

    if (!key) return;

    option.dataset.customOption = key;

    if (BUTTON_OPTIONS.includes(key)) {
      option.classList.add("c-option-button");
    }

    option.dataset.optionReady = "1";
  }

  function run() {
    document.querySelectorAll(".po-option-root").forEach(markOption);
    document.querySelectorAll(ROW_SELECTOR).forEach(setupCarousel);
  }

  // DOM監視（アプリ遅延読み込み対策）
  function setupMutationObserver() {
    let timer;
    const observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(run, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  run();
  setupMutationObserver();
});

// Message card
document.addEventListener("DOMContentLoaded", function () {
  const ATC_SELECTOR = "#AddToCart";
  const MESSAGE_ROOT = '[data-custom-option="message"]';
  const CARD_ROOT = '[data-custom-option="card"]';

  function syncMessageAtc() {
    const button = document.querySelector(ATC_SELECTOR);
    if (!button) return;
    if ((button.textContent || "").indexOf("売り切れ") !== -1) return;

    const root = document.querySelector(MESSAGE_ROOT);
    if (!root) {
      if (button.dataset.blockedByMessage === "1") {
        button.disabled = false;
        delete button.dataset.blockedByMessage;
      }
      return;
    }

    const style = window.getComputedStyle(root);
    const visible =
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      root.offsetWidth > 0;

    const textarea = root.querySelector("textarea");
    const empty = visible && textarea && textarea.value.trim() === "";

    if (empty) {
      button.disabled = true;
      button.dataset.blockedByMessage = "1";
    } else if (button.dataset.blockedByMessage === "1") {
      // Only enable button if this function itself blocked it previously
      button.disabled = false;
      delete button.dataset.blockedByMessage;
    }
  }
  function syncSoon() {
    setTimeout(syncMessageAtc, 80);
  }

  document.addEventListener("input", function (e) {
    if (e.target.closest(MESSAGE_ROOT)) syncMessageAtc();
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest(CARD_ROOT)) syncSoon();
  });

  let timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(syncMessageAtc, 50);
  }).observe(document.body, { childList: true, subtree: true });

  syncMessageAtc();
});
